import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import WhatsAppButton from "@/components/WhatsAppButton";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";

export default function Layout() {
  return (
    <div className="App grain min-h-screen flex flex-col bg-canvas text-ink overflow-x-hidden">
      <Navbar />
      <WhatsAppButton />
      <main className="flex-1 pt-20 relative z-[2]">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
